import { Card, CardContent, Checkbox } from "@material-ui/core";
import { Box, Button, Grid2, Typography } from "@mui/material";
import { Reorder } from "framer-motion";
import React, { useEffect, useState } from "react";
import { Edit3 } from "react-feather";
import commonStyles from "../../../Utils/commonStyles";
import announcementsImage from "../../../Utils/images/announcements.png";
import asset_trend from "../../../Utils/images/asset_trend.png";
import countdown from "../../../Utils/images/countdown.png";
import delayed_tasks from "../../../Utils/images/delayed_tasks.png";
import file_review_trend from "../../../Utils/images/file_review_trend.png";
import my_todos from "../../../Utils/images/my_todos.png";
import project_health from "../../../Utils/images/project_health.png";
import project_performance from "../../../Utils/images/project_performence.png";
import project_productivity from "../../../Utils/images/project_productivity.png";
import shot_trend from "../../../Utils/images/shot_trend.png";
import storage_overview from "../../../Utils/images/storage_overview.png";
import task_trend from "../../../Utils/images/task_trend.png";
import user_score from "../../../Utils/images/user_score.png";
import project_reviews from "../../../Utils/images/project_reviews.png";
import task_overview from "../../../Utils/images/task_overview.png";
import useStyles from "./ExtendDeadlineModal.style";
import {
  Heartbeat,
  Database,
  DotsSix,
  X,
  SquaresFour,
  HourglassSimpleLow,
  CheckSquareOffset,
  ChartBar,
  CalendarCheck,
  Gauge,
} from "phosphor-react";
import ChitranSvg from "../../Utilities/Svg/ChitranSvg";

const iconMap = {
  project_health: Heartbeat,
  countdown: HourglassSimpleLow,
  delayed_tasks: CheckSquareOffset,
  storage_overview: Database,
  my_todos: CalendarCheck,
  user_score: Gauge,
  task_overview: ChartBar,
  project_reviews: ChartBar,
};

const CreateUpdatePageLayoutModal = ({
  type,
  handleClose,
  handleUpdate,
  initialLayout,
}) => {
  const commonClasses = commonStyles();
  const classes = useStyles();

  const [selectedColumn, setSelectedColumn] = useState("left");
  const [widgets, setWidgets] = useState([
    {
      id: 1,
      name: "Project Health",
      slug: "project_health",
      imageUrl: project_health,
      position: 0,
      isSelected: false,
      column: "left",
      iconColor: "#E24A82",
    },
    /* {
      id: 2,
      name: "Project Productivity",
      slug:'project_productivity',
      imageUrl: project_productivity,
      position: 0,
      isSelected: false,
      column: "left",
      iconColor: "#659BD9",
    }, */
    {
      id: 3,
      name: "Countdown",
      slug: "countdown",
      imageUrl: countdown,
      position: 0,
      isSelected: false,
      column: "left",
      iconColor: "#54E9B5",
    },
    /* {
      id: 4,
      name: "Announcements",
      slug:'announcements',
      imageUrl: announcementsImage,
      position: 0,
      isSelected: false,
      column: "left",
      iconColor: "yellow",
    }, */
    /* {
      id: 5,
      name: "Asset Trend",
      slug:'asset_trend',
      imageUrl: asset_trend,
      position: 0,
      isSelected: false,
      column: "left",
      iconColor: "blue",
    }, */
    {
      id: 6,
      name: "Delayed Tasks",
      slug: "delayed_tasks",
      imageUrl: delayed_tasks,
      position: 0,
      isSelected: false,
      column: "left",
      iconColor: "#FF0000",
    },
    /* {
      id: 7,
      name: "Storage Overview",
      slug: "storage_overview",
      imageUrl: storage_overview,
      position: 0,
      isSelected: false,
      column: "right",
      iconColor: "#4D9BF4",
    }, */
    /* {
      id: 8,
      name: "Shot Trend",
      slug:'shot_trend',
      imageUrl: shot_trend,
      position: 0,
      isSelected: false,
      column: "right",
      iconColor: "blue",
    }, */
    {
      id: 9,
      name: "My Todos",
      slug: "my_todos",
      imageUrl: my_todos,
      position: 0,
      isSelected: false,
      column: "right",
      iconColor: "#F5944E",
    },
    /* {
      id: 10,
      name: "File review Trend",
      slug:'file_review_trend',
      imageUrl: file_review_trend,
      position: 0,
      isSelected: false,
      column: "right",
      iconColor: "blue",
    }, */
    /* {
      id: 11,
      name: "Project Performance",
      slug:'project_performance',
      imageUrl: project_performance,
      position: 0,
      isSelected: false,
      column: "left",
      iconColor: "blue",
    }, */
    {
      id: 12,
      name: "User Score",
      slug: "user_score",
      imageUrl: user_score,
      position: 0,
      isSelected: false,
      column: "right",
      iconColor: "#6C65D9",
    },
    /* {
      id: 13,
      name: "Task Trend",
      slug:'task_trend',
      imageUrl: task_trend,
      position: 0,
      isSelected: false,
      column: "right",
      iconColor: "blue",
    }, */
    {
      id: 14,
      name: "Task Overview",
      slug: "task_overview",
      imageUrl: task_overview,
      position: 0,
      isSelected: false,
      column: "right",
      iconColor: "#6C65D9",
    },
    {
      id: 15,
      name: "Project Reviews",
      slug: "project_reviews",
      imageUrl: project_reviews,
      position: 0,
      isSelected: false,
      column: "left",
      iconColor: "#6C65D9",
    },
  ]);

  const handleToggle = (id) => {
    setWidgets((prevWidgets) =>
      prevWidgets.map((widget) =>
        widget.id === id
          ? { ...widget, isSelected: !widget.isSelected }
          : widget
      )
    );
  };

  const handleReorder = (newOrder, column) => {
    setWidgets((prevWidgets) => {
      const reordered = newOrder.map((widget, index) => ({
        ...widget,
        position: index + 1,
      }));
      const others = prevWidgets.filter((w) => w.column !== column);
      return [...others, ...reordered];
    });
  };

  const handleSaveLayout = () => {
    const layouts = JSON.parse(localStorage.getItem("layouts")) || [];

    if (type === "new") {
      const newLayout = {
        name: `Layout ${layouts.length + 1}`,
        layout: widgets,
      };
      localStorage.setItem("layouts", JSON.stringify([...layouts, newLayout]));
    } else if (type === "edit" && initialLayout) {
      const updatedLayouts = layouts.map((layout) =>
        layout.name === initialLayout.name
          ? { ...layout, layout: widgets }
          : layout
      );
      localStorage.setItem("layouts", JSON.stringify(updatedLayouts));
    }

    handleUpdate();
    handleClose();
  };

  useEffect(() => {
    if (type === "edit" && initialLayout) {
      setWidgets(initialLayout?.layout);
    }
  }, [type, initialLayout]);

  const renderWidgets = (column) => {
    // Separate and sort selected and unselected widgets
    const sortedWidgets = widgets
      .filter((w) => w.column === column)
      .sort((a, b) => {
        if (a.isSelected === b.isSelected) {
          return a.position - b.position; // Maintain the original order if same selection status
        }
        return b.isSelected - a.isSelected; // Selected items go to the top
      });

    return (
      <Reorder.Group
        axis="y"
        values={sortedWidgets}
        className={classes.widgetsList}
        onReorder={(order) => {
          // Prevent unselected items from going above selected items
          const reordered = [...order].sort(
            (a, b) => b.isSelected - a.isSelected
          );
          handleReorder(reordered, column);
        }}
      >
        {sortedWidgets.map((widget, index) => {
          const IconComponent = iconMap[widget.slug];
          return (
            <Reorder.Item
              key={widget.id}
              value={widget}
              className={classes.singleWidgetName}
              style={{
                borderBottom:
                  sortedWidgets.length - 1 === index
                    ? "none"
                    : "2px solid #1B1D28",
              }}
            >
              <Box className={commonClasses.flexAndGap8Px}>
                <Checkbox
                  checked={widget.isSelected}
                  onChange={() => handleToggle(widget.id)}
                />
                {IconComponent && (
                  <IconComponent
                    size={20}
                    fill={widget.iconColor}
                    weight="fill"
                  />
                )}
                <Typography>{widget.name}</Typography>
              </Box>
              {widget.isSelected && (
                <DotsSix size={20} style={{ cursor: "grab" }} />
              )}
            </Reorder.Item>
          );
        })}
      </Reorder.Group>
    );
  };

  const renderWidgetPreview = (column) => {
    const selectedWidgets = widgets?.filter(
      (sin) => sin.column === column && sin.isSelected
    );

    return (
      <Box
        display="flex"
        flexDirection="column"
        gap={2}
        paddingRight={1}
        minWidth={{ md: "300px", lg: "350px", xl: "400px" }}
        sx={{ overflowX: "hidden" }}
      >
        {selectedWidgets?.length ? (
          selectedWidgets?.map((sin) => (
            <img src={sin.imageUrl} alt={sin.name} width="100%" />
          ))
        ) : (
          <Box
            sx={{
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              gap: 2,
            }}
          >
            <ChitranSvg />
            <Typography sx={{ textAlign: "center" }}>
              Your {column} Column is empty. Add widgets <br />
              to customize your workspace!
            </Typography>
          </Box>
        )}
      </Box>
    );
  };

  return (
    <Card className={classes.editLayoutCard}>
      <CardContent className={classes.editLayoutCardContent}>
        <Box className={commonClasses.flexBetween}>
          <Box className={commonClasses.flexAndGap8Px}>
            <SquaresFour size={24} />
            <Typography sx={{ fontWeight: 600, fontSize: "22px !important" }}>
              {type === "new" ? "Add Layout" : "Edit Layout"}
            </Typography>
          </Box>
          <Button
            onClick={handleClose}
            sx={{ color: "white", p: 0, minWidth: 0 }}
          >
            <X size={22} />
          </Button>
        </Box>
        <Grid2 container spacing={2} sx={{ width: "100%" }}>
          <Grid2 size={3}>
            <Box sx={{ height: "100%" }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  mb: 1,
                }}
              >
                <Button
                  sx={{
                    width: "100%",
                    borderBottom:
                      selectedColumn === "left"
                        ? "2px solid #6C65D9"
                        : "2px solid transparent",
                    color: selectedColumn === "left" ? "white" : "gray",
                    minWidth: "150px",
                    borderRadius: "0px",
                  }}
                  onClick={() => setSelectedColumn("left")}
                >
                  Left Column
                </Button>
                <Button
                  sx={{
                    width: "100%",
                    borderBottom:
                      selectedColumn === "right"
                        ? "2px solid #6C65D9"
                        : "2px solid transparent",
                    color: selectedColumn === "right" ? "white" : "gray",
                    minWidth: "150px",
                    borderRadius: "0px",
                  }}
                  onClick={() => setSelectedColumn("right")}
                >
                  Right Column
                </Button>
              </Box>
              {selectedColumn === "left"
                ? renderWidgets("left")
                : renderWidgets("right")}
            </Box>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              color="#606479"
            >
              <Typography
                sx={{
                  fontSize: {
                    md: "12px !important",
                    lg: "14px !important",
                  },
                }}
              >
                Left Column :{" "}
                {
                  widgets.filter((w) => w.column === "left" && w.isSelected)
                    .length
                }
              </Typography>
              <Typography
                sx={{
                  fontSize: {
                    md: "12px !important",
                    lg: "14px !important",
                  },
                }}
              >
                Right Column :{" "}
                {
                  widgets.filter((w) => w.column === "right" && w.isSelected)
                    .length
                }
              </Typography>
            </Box>
          </Grid2>
          <Grid2 size={9} sx={{ height: "70vh", overflowY: "auto" }}>
            {widgets.filter((w) => w.isSelected).length ? (
              <Grid2 container spacing={2}>
                <Grid2 size={6}>{renderWidgetPreview("left")}</Grid2>
                <Grid2 size={6}>{renderWidgetPreview("right")}</Grid2>
              </Grid2>
            ) : (
              <Box
                sx={{
                  height: "70vh",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                  gap: 2,
                }}
              >
                <ChitranSvg />
                <Typography sx={{ textAlign: "center" }}>
                  Your layout is empty. Add widgets <br />
                  to customize your workspace!
                </Typography>
              </Box>
            )}
          </Grid2>
        </Grid2>
        <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
          <Button variant="outlined" sx={{ width: "200px", color: "white" }}>
            Revert Changes
          </Button>
          <Button
            variant="contained"
            onClick={handleSaveLayout}
            sx={{ width: "200px" }}
            disabled={widgets.filter((w) => w.isSelected).length === 0}
          >
            {type === "new" ? "Save Layout" : "Update Layout"}
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

export default CreateUpdatePageLayoutModal;
